import { IUser } from '../../modules/Auth/models/user.model';
import PlatformModules from '../accessControl/Modules';

export const showChipAprovaLive = (meData: IUser | null) => {
  if (!meData) return false;
  
  const today = new Date();
  const endDate = new Date('2024-02-23T18:00:00');

  if (today > endDate) {
    return false;
  }
  const permissions = meData?.permissions;

  if (!permissions) {
    return false;
  }

  const hasAprovaLive = (permissions?.modulesGranted || []).includes(
    PlatformModules.APROVA_LIVE.ID
  );

  const isSubscriber = permissions.isSubscriber;

  return !hasAprovaLive && isSubscriber;
};
